import { withSvgProps } from './helpers'
import { ReactComponent as SvgComponent } from './svg/left-arrow.svg'

type SvgProps = React.ComponentProps<typeof SvgComponent>

const Svg: React.FC<SvgProps> = (props) => <SvgComponent {...props} />

export const LeftArrow = withSvgProps(Svg)
